import { ConverterTypes } from './constants'


class BaseConverter {
  constructor(markupIdentifier, converterType) {
    this.markupIdentifier = markupIdentifier
    this.converterType = converterType
    this.isElement = this.converterType === ConverterTypes.ELEMENT
    this.isOption = this.converterType === ConverterTypes.OPTION
    this.isText = this.converterType === ConverterTypes.TEXT
  }
}

export default BaseConverter